import React from "react";
import { Route, Routes } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Header from "components/Header";
import Sidebar from "containers/SideNav/index";
import Footer from "components/Footer";
import Tour from "components/Tour";
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";
import { isIOS, isMobile } from "react-device-detect";
import TopNav from "components/TopNav";
import AdminProfile from "./routes/ProfileAdmin/components";
import GlobalMessageDialog from "components/GlobalMessageDialog";
import VirtualCards from "./routes/Cards/routes/VirtualCards";
import PhysicalCards from "./routes/Cards/routes/PhysicalCards";
import CardDetail from "./routes/Cards/routes/CardDetail";
import { IdleTimerProvider } from "react-idle-timer";
import { logoutRequestAction } from "redux/actions/AuthActions";
import Error404 from "components/Error404";
import CreateCreditCard from "./routes/Cards/routes/CreditCard/CreateCreditCard";
import CreatePhysicalCard from "./routes/Cards/routes/CreditCard/CreatePhysicalCard";
import TopupCard from "./routes/Cards/routes/TopupCard";
import AddCard from "./routes/Cards/routes/CreditCard/AddCard";
import WalletTransactions from "./routes/Wallet/WalletTransactions";
import WalletBalances from "./routes/Wallet//WalletBalances";

const App = () => {
  const currentUrl = "/app";
  const dispatch = useDispatch();

  const { drawerType, navigationStyle, horizontalNavPosition } = useSelector(
    ({ settings }) => {
      return {
        drawerType: settings.drawerType,
        navigationStyle: settings.navigationStyle,
        horizontalNavPosition: settings.horizontalNavPosition,
      };
    },
    shallowEqual
  );

  // useEffect(() => {
  //   const handleBeforeUnload = async (event) => {
  //     // Check if it's a hard refresh
  //     if (performance.navigation.type === 1) {
  //       // Ignore the code on hard refresh
  //       return;
  //     }

  //     dispatch(logoutRequestAction({ userID: user.id }));
  //   };

  //   window.addEventListener("load", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("load", handleBeforeUnload);
  //   };
  // }, []);

  const drawerStyle = drawerType.includes(FIXED_DRAWER)
    ? "fixed-drawer"
    : drawerType.includes(COLLAPSED_DRAWER)
    ? "collapsible-drawer"
    : "mini-drawer";

  //set default height and overflow for iOS mobile Safari 10+ support.
  if (isIOS && isMobile) {
    document.body.classList.add("ios-mobile-view-height");
  } else if (document.body.classList.contains("ios-mobile-view-height")) {
    document.body.classList.remove("ios-mobile-view-height");
  }

  return (
    <IdleTimerProvider
      timeout={1000 * 60 * 30}
      onIdle={() => dispatch(logoutRequestAction())}
    >
      <div className={`app-container ${drawerStyle}`}>
        <Tour />
        <Sidebar />
        <div className="app-main-container">
          <div
            className={`app-header ${
              navigationStyle === HORIZONTAL_NAVIGATION
                ? "app-header-horizontal"
                : ""
            }`}
          >
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === ABOVE_THE_HEADER && (
                <TopNav styleName="app-top-header" />
              )}
            <Header />
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
          </div>
          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <div className="app-wrapper">
                <GlobalMessageDialog />
                <Routes>
                  <Route path="/not-found" element={<Error404 />} />
                  <Route path="cards">
                    <Route path="physical-cards" element={<PhysicalCards />} />
                    <Route path="top-up" element={<TopupCard />} />
                    <Route path="virtual-cards" element={<VirtualCards />} />
                    <Route
                      path="request-virtual-card"
                      element={<CreateCreditCard />}
                    />
                    <Route
                      path="request-physical-card"
                      element={<CreatePhysicalCard />}
                    />
                    <Route path="add-card" element={<AddCard />} />
                    <Route path=":id" element={<CardDetail />} />
                  </Route>
                  <Route path="wallet">
                    <Route path="balances" element={<WalletBalances />} />
                    <Route
                      path="transactions"
                      element={<WalletTransactions />}
                    />
                  </Route>
                </Routes>
              </div>
            </div>
            <Footer />
          </main>
        </div>
      </div>
    </IdleTimerProvider>
  );
};

export default App;
